import type { SubscriptionDto } from "../core/api/use-get-subscriptions/SubscriptionDto";
import { store, type GovernmentAgencyHubAppStoreSlice } from "./store";

export interface SessionStoreSlice {
    subscriptions: SubscriptionDto[];
}

const defaultValues: SessionStoreSlice = {
    subscriptions: [],
};

const resetValues = () => {
    updateValues({
        ...defaultValues,
    });
};

const updateValues = (newValues: Partial<SessionStoreSlice>) => {
    store.setState((state) => ({
        ...state,
        session: {
            ...state.session,
            ...newValues,
        },
    }));
};

export const sessionStoreSlice: GovernmentAgencyHubAppStoreSlice<SessionStoreSlice> =
    {
        defaultValues: defaultValues,
        resetValues: resetValues,
        updateValues: updateValues,
    };
